var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrid2X2 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.667 1.25C13.8173 1.25018 14.7498 2.18267 14.75 3.33301V12.667C14.7498 13.8173 13.8173 14.7498 12.667 14.75H3.33301C2.18267 14.7498 1.25018 13.8173 1.25 12.667V3.33301C1.25018 2.18267 2.18267 1.25018 3.33301 1.25H12.667ZM2.75 8.75V12.667C2.75018 12.9889 3.0111 13.2498 3.33301 13.25H7.25V8.75H2.75ZM8.75 8.75V13.25H12.667C12.9889 13.2498 13.2498 12.9889 13.25 12.667V8.75H8.75ZM3.33301 2.75C3.0111 2.75018 2.75018 3.0111 2.75 3.33301V7.25H7.25V2.75H3.33301ZM8.75 7.25H13.25V3.33301C13.2498 3.0111 12.9889 2.75018 12.667 2.75H8.75V7.25Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrid2X2);
export default ForwardRef;